export interface CountrySpecificData {
  country: string;
  highlights: string[];
}

// Country-specific data for Question 13
// This data is auto-generated from content-management/generated/country-data.csv
// To update: Run "npm run country:import" after editing the CSV file
export const countrySpecificData: CountrySpecificData[] = [
  {
    country: "Austria",
    highlights: [
      "100% laying hens are cage free",
      "24 food companies cage free",
      "Cages for meat rabbits banned",
      "Enriched cages for laying hens banned since 2020.",
      "Foie gras production banned"
    ]
  },
  {
    country: "Belgium",
    highlights: [
      "65% laying hens are cage free",
      "100% rabbits cage free",
      "74 food companies are cage free",
      "Foie gras production banned"
    ]
  },
  {
    country: "Bulgaria",
    highlights: [
      "54 food companies are cage free"
    ]
  },
  {
    country: "Croatia",
    highlights: [
      "66% laying hens are cage free",
      "14 food companies are cage free",
      "90% of citizens said it was important to protect the welfare of farmed animals. (According to the Eurobarometer survey 2023)",
      "Foie gras production banned"
    ]
  },
  {
    country: "Czech Republic",
    highlights: [
      "41 food companies cage free",
      "Foie gras production banned"
    ]
  },
  {
    country: "Denmark",
    highlights: [
      "90% laying hens are cage free",
      "37 food companies cage free",
      "Denmark banned the production of eggs from caged hens in 2023, allowing a transition period for existing farms.",
      "Foie gras production banned"
    ]
  },
  {
    country: "Estonia",
    highlights: [
      "53 food companies cage free",
      "Foie gras production banned"
    ]
  },
  {
    country: "Finland",
    highlights: [
      "76% laying hens are cage free",
      "66 food companies are cage free",
      "Foie gras production banned"
    ]
  },
  {
    country: "France",
    highlights: [
      "70% laying hens are cage free",
      "85 food companies are cage free",
      "94% of citizens said it is important to ensure that animals are not kept in individual cages",
      "3 food businesses 100% cage free for their pig meat",
      "5 food businesses 100% cage free for their meat rabbits"
    ]
  },
  {
    country: "Germany",
    highlights: [
      "96% laying hens are cage free",
      "274 food companies are cage free",
      "90% of citizens said it was important to protect the welfare of farmed animals.",
      "92% of citizens said it is important to ensure that animals are not kept in individual cages.",
      "Committed to phasing out sow stalls by 2029",
      "Foie gras production banned"
    ]
  },
  {
    country: "Greece",
    highlights: [
    ]
  },
  {
    country: "Hungary",
    highlights: [
    ]
  },
  {
    country: "Ireland",
    highlights: [
      "78% laying hens are cage free",
      "17 food companies are cage free",
      "94% of citizens said it is important to ensure that animals are not kept in individual cages.",
      "Foie gras production banned"
    ]
  },
  {
    country: "Italy",
    highlights: [
      "66% laying hens are cage free",
      "53 food companies are cage free",
      "92% of citizens said it is important to ensure that animals are not kept in individual cages",
      "5 food businesses 100% cage free for their pig meat",
      "Foie gras production banned"
    ]
  },
  {
    country: "Latvia",
    highlights: [
      "45 food companies cage free",
      "Foie gras production banned"
    ]
  },
  {
    country: "Lithuania",
    highlights: [
      "63 food companies cage free",
      "Foie gras production banned"
    ]
  },
  {
    country: "Luxembourg",
    highlights: [
      "100% laying hens are cage free",
      "12 food companies are cage free",
      "95% of citizens said it is important to ensure that animals are not kept in individual cages.",
      "Foie gras production banned"
    ]
  },
  {
    country: "Malta",
    highlights: [
    ]
  },
  {
    country: "Netherlands",
    highlights: [
      "85% laying hens are cage free",
      "60% rabbits cage free",
      "30 food companies are cage free",
      "Battery cages are banned for laying hens",
      "Barren cages are banned for rabbits",
      "Foie gras production banned"
    ]
  },
  {
    country: "Poland",
    highlights: [
      "30 food companies are cage free",
      "Foie gras production banned"
    ]
  },
  {
    country: "Portugal",
    highlights: [
      "19 food companies cage free",
      "Foie gras production banned"
    ]
  },
  {
    country: "Romania",
    highlights: [
      "47 food companies cage free",
      "Foie gras production banned"
    ]
  },
  {
    country: "Slovakia",
    highlights: [
    ]
  },
  {
    country: "Slovenia",
    highlights: [
      "86% laying hens are cage free",
      "10 food companies are cage free",
      "95% of citizens said it is important to ensure that animals are not kept in individual cages.",
      "Pigs are 77% cage free.",
      "Foie gras production banned"
    ]
  },
  {
    country: "Spain",
    highlights: [
      "44 food companies are cage free",
      "Foie gras production banned"
    ]
  },
  {
    country: "Sweden",
    highlights: [
      "97% laying hens are cage free",
      "100% rabbits cage free",
      "91 food companies are cage free",
      "92% of citizens would be willing to pay more for products sourced from animal welfare-friendly farming systems.",
      "Sow stalls and farrowing crates are banned.",
      "Foie gras production banned"
    ]
  },
  {
    country: "Other",
    highlights: [
      "Many countries are working towards higher animal welfare standards"
    ]
  }
];

export function getCountryData(country: string): CountrySpecificData | undefined {
  return countrySpecificData.find(data => data.country === country);
}

/**
 * Maps country code (e.g., "GB", "FR") to country name (e.g., "United Kingdom", "France")
 * Used to convert signup country codes to country names for lookup in countrySpecificData
 */
export function getCountryNameFromCode(code: string): string | null {
  // Import countries array dynamically to avoid circular dependency
  // Common EU country code mappings
  const codeToNameMap: Record<string, string> = {
    'AT': 'Austria',
    'BE': 'Belgium',
    'BG': 'Bulgaria',
    'HR': 'Croatia',
    'CY': 'Cyprus',
    'CZ': 'Czech Republic',
    'DK': 'Denmark',
    'EE': 'Estonia',
    'FI': 'Finland',
    'FR': 'France',
    'DE': 'Germany',
    'GR': 'Greece',
    'HU': 'Hungary',
    'IE': 'Ireland',
    'IT': 'Italy',
    'LV': 'Latvia',
    'LT': 'Lithuania',
    'LU': 'Luxembourg',
    'MT': 'Malta',
    'NL': 'Netherlands',
    'PL': 'Poland',
    'PT': 'Portugal',
    'RO': 'Romania',
    'SK': 'Slovakia',
    'SI': 'Slovenia',
    'ES': 'Spain',
    'SE': 'Sweden',
    'GB': 'United Kingdom',
  };
  
  return codeToNameMap[code] || null;
}

/**
 * Gets country-specific key points (highlights) by country code
 * @param countryCode - ISO country code (e.g., "GB", "FR")
 * @returns Array of highlight strings, or empty array if not found
 */
export function getCountryKeyPoints(countryCode: string): string[] {
  const countryName = getCountryNameFromCode(countryCode);
  if (!countryName) {
    return [];
  }
  
  const countryData = getCountryData(countryName);
  return countryData?.highlights || [];
}

/**
 * Gets list of EU countries available in countrySpecificData
 * Returns array of country names for dropdown display
 */
export function getAvailableCountries(): string[] {
  return countrySpecificData
    .filter(data => data.country !== 'Other')
    .map(data => data.country)
    .sort();
}
